import CustomVideoPlayer from '../../CustomVideoPlayer'
import ImageBox from './components/ImageBox'
import StorybookEmbed from '../../components/storybook-embed'

export default {CustomVideoPlayer, ImageBox, StorybookEmbed}
